export default __webpack_public_path__ + "static/media/stake-more-roya.f962bf6d.svg";